import { createFileRoute } from "@tanstack/react-router"
import { CommunicationAnnouncementsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/announcements/"
)({
  component: () => (
    <AuthorizationGate resource={Resource.ANNOUNCEMENT} action={Action.READ}>
      <CommunicationAnnouncementsPage />
    </AuthorizationGate>
  ),
})
